import React, { useEffect } from 'react';
import LandingSection from '../pages/landingPage/LandingSection';
import Industry from '../pages/industry/Industry';
import OurProductsHome from '../pages/ourProducts/OurProductsHome';
import { useProductData } from '../../common/functions/userProductData/UserProductData';
import { useLoader } from '../../common/Context/LoaderContext';
import { useAlert } from '../../common/Context/AlertContext';

function LandingLayout() {
  const { showAlert } = useAlert();
  const { setLoading } = useLoader();

  const { products } = useProductData(showAlert, setLoading);

  return (
    <div className="">
      <LandingSection />
      <OurProductsHome products={products} />
      <Industry />
    </div>
  );
}

export default LandingLayout;
